import { FormControlLabel, Radio, Tooltip, Typography } from '@lyearn/ui';

const CLASSES = {
  label: 'body-short-01',
  root: 'ms-0 me-0',
};

interface RadioItemProps {
  checked: boolean;
  disabled?: boolean;
  label: string;
  tooltipLabel?: string;
  onChange: (checked: boolean) => void;
}

function RadioItem({ checked, disabled, label, tooltipLabel, onChange }: RadioItemProps) {
  const labelComp = (
    <Typography className={disabled ? 'opacity-50' : undefined} variant="body-short-01">
      {label}
    </Typography>
  );

  return (
    <FormControlLabel
      checked={checked}
      classes={CLASSES}
      control={<Radio className="me-12" size="small" />}
      disabled={disabled}
      label={
        disabled && tooltipLabel ? (
          <Tooltip placement="right" title={tooltipLabel}>
            {labelComp}
          </Tooltip>
        ) : (
          labelComp
        )
      }
      onChange={(e, checked) => onChange(checked)}
    />
  );
}

export default RadioItem;
